import React from 'react';
function formatServerErrors(errorsArray, i18n) {
  if (Array.isArray(errorsArray.error)) {
    return errorsArray.error.reduce(function (map, obj) {
      if (obj.language) {
        if (obj.language.includes('en')) {
          map[obj.field + '_en'] = map[obj.field + '_en'] || [];
          map[obj.field + '_en'].push(obj.message + ' (' + i18n.t('styleguide:languages.english') + ')');
        }
        if (obj.language.includes('cy')) {
          map[obj.field + '_cy'] = map[obj.field + '_cy'] || [];
          map[obj.field + '_cy'].push(obj.message + ' (' + i18n.t('styleguide:languages.welsh') + ')');
        }
      } else {
        map[obj.field] = map[obj.field] || [];
        map[obj.field].push(obj.message);
      }

      return map;
    }, {});
  } else {
    return {};
  }
}

export default formatServerErrors;
